import { useQuery } from '@tanstack/react-query'
import { fetchApi } from '@/common/lib/fetchApi'

export interface EmployeeListItem {
  id: number
  first_name: string
  last_name: string
  email: string | null
  department: string | null
  job_title: string | null
  employment_status: string
  timesheet_exempt: boolean
}

export function useAdminEmployees(search?: string, includeInactive = false) {
  const query = new URLSearchParams()
  if (search) query.set('search', search)
  if (includeInactive) query.set('include_inactive', 'true')
  const queryString = query.toString()
  const params = queryString ? `?${queryString}` : ''

  return useQuery({
    queryKey: ['admin', 'employees', search ?? '', includeInactive],
    queryFn: () => fetchApi<EmployeeListItem[]>(`/api/org/employees${params}`),
  })
}
